import React, { useState, useEffect } from "react"
import {
  Card,
  Table,
  Button,
  Modal,
  Input,
  Icon,
  Divider,
  Select,
  Dimmer,
  Loader,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { apiGet, apiPost, apiPut, apiDelete } from "../utils/apiConnector"
import { employeeApi, employeeListApi, storeListApi } from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"
import ECPComponent from "../components/ECPcomponent"
import { signOut } from "../ducks/profile"

const EmployeePage = () => {
  const { t } = useTranslation()
  const [employees, setEmployees] = useState([])
  const [modal, setModal] = useState(false)
  const [name, setName] = useState("")
  const [login, setLogin] = useState("")
  const [mail, setMail] = useState("")
  const [pwd, setPwd] = useState("")
  const [confPwd, setConfPwd] = useState("")
  const [phone, setPhone] = useState("")
  const [isDel, setIsDel] = useState(false)
  const [edit, setEdit] = useState(false)
  const [editing, setEditing] = useState(null)
  const [x509, setX509] = useState("")
  const [ecpCreate, setEcpCreate] = useState(false)
  const [choosed, setChoosed] = useState(null)
  const [lines, setLines] = useState([])
  const [stores, setStores] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [confirming, setConfirming] = useState(false)
  const [id, setId] = useState("")
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const getLines = () => {
    apiGet(storeListApi, {})
      .onOk((res) => {
        console.log(res.data.response)
        setLines(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {})
      .startSingle()
  }
  const getEmployees = () => {
    const id = profile.id
    if (id) {
      setIsLoading(true)
      apiGet(employeeListApi + "/" + id, {})
        .onOk((res) => {
          setEmployees(res.data.response)
        })
        .onFail((res) => {})
        .afterAll(() => {
          setIsLoading(false)
        })
        .startSingle()
    }
  }
  const postEmployee = () => {
    const oid = profile.id
    const roles = [1, 2, 3, 4]
    if (stores.length) {
      const req = {
        login,
        name,
        phone,
        mail,
        pass: pwd,
        stores: stores,
        roles,
        x509,
      }
      if (oid) {
        apiPost(employeeApi + "/" + oid, req)
          .onOk((res) => {})
          .onFail((res) => {})
          .afterAll(() => {
            closeModal()
            getEmployees()
          })
          .startSingle()
      }
    }
  }
  const putEmployee = (q) => {
    const oid = profile.id
    if (oid) {
      const req = {}
      req.id = q.id
      req.name = name !== "" ? name : q.name
      req.phone = phone !== "" ? phone : q.phone
      req.mail = mail !== "" ? mail : q.mail
      req.stores = stores.length > 0 ? stores : q.stores
      if (x509) {
        req.x509 = x509
      }
      apiPut(employeeApi + "/" + oid, req)
        .onOk((res) => {})
        .onFail((res) => {})
        .afterAll(() => {
          closeModal()
          getEmployees()
        })
        .startSingle()
    }
  }
  const deleteEmployee = (id) => {
    apiDelete(employeeApi + "/" + id, {})
      .onOk((res) => {})
      .onFail((res) => {})
      .afterAll(() => {
        getEmployees()
        setConfirming(false)
        setIsDel(false)
        setId("")
      })
      .startSingle()
  }
  const closeModal = () => {
    setModal(false)
    setEdit(false)
    setEditing(null)
    setName("")
    setLogin("")
    setPwd("")
    setConfPwd("")
    setMail("")
    setPhone("")
    setStores([])
  }
  useEffect(() => {
    getLines()
    getEmployees()
    return () => {}
  }, [])
  const confirmDeleteRender = () => {
    return (
      <>
        <Modal
          size="tiny"
          open={confirming}
          onClose={() => {
            setConfirming(false)
            setIsDel(false)
            setId("")
          }}
          style={{ height: "max-content", marginTop: "-40vh" }}
        >
          <Card fluid>
            <Card.Header>
              <h3 style={{ margin: 10 }}>{t("Подтвердить удаление")}</h3>
            </Card.Header>
            <Card.Content>
              <div
                style={{
                  maring: 10,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  negative
                  content={t("Cancel")}
                  onClick={() => {
                    setConfirming(false)
                    setIsDel(false)
                    setId("")
                  }}
                />
                <Button
                  positive
                  content={t("Submit")}
                  onClick={() => {
                    deleteEmployee(id)
                  }}
                />
              </div>
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  const renderCreateEmployee = () => {
    return (
      <>
        <Modal
          size="tiny"
          open={modal}
          onClose={closeModal}
          style={{ height: "max-content", marginTop: "-40vh" }}
        >
          <Card fluid>
            <Card.Header>
              <h3 style={{ margin: 10 }}>
                {edit ? t("Edit employee") : t("Create employee")}
              </h3>
            </Card.Header>
            <Card.Content>
              <Table fluid style={{ border: "0px solid red" }}>
                <Table.Body>
                  {!edit ? (
                    <>
                      <Table.Row>
                        <Table.Cell style={{ width: 70 }}>
                          <b>{t("Login")}:</b>
                        </Table.Cell>
                        <Table.Cell>
                          <Input
                            fluid
                            type="number"
                            value={login}
                            onChange={(e, d) => {
                              setLogin(d.value)
                            }}
                          />
                        </Table.Cell>
                      </Table.Row>
                    </>
                  ) : (
                    <></>
                  )}
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Name Surname")}:</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        fluid
                        value={name}
                        placeholder={edit ? editing.name : ""}
                        onChange={(e, d) => {
                          setName(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                  {!edit ? (
                    <>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Password")}:</b>
                        </Table.Cell>
                        <Table.Cell>
                          <Input
                            fluid
                            type="password"
                            value={pwd}
                            onChange={(e, d) => {
                              setPwd(d.value)
                            }}
                          />
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Confirm password")}:</b>
                        </Table.Cell>
                        <Table.Cell>
                          <Input
                            fluid
                            type="password"
                            value={confPwd}
                            onChange={(e, d) => {
                              setConfPwd(d.value)
                            }}
                            error={pwd !== "" && confPwd !== pwd}
                            disabled={pwd === ""}
                          />
                        </Table.Cell>
                      </Table.Row>
                    </>
                  ) : (
                    <></>
                  )}
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Email")}:</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        fluid
                        type="email"
                        placeholder={edit ? editing.mail : ""}
                        value={mail}
                        onChange={(e, d) => {
                          setMail(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Mobile phone")}:</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        fluid
                        type="number"
                        value={phone}
                        placeholder={edit ? editing.phone : ""}
                        onChange={(e, d) => {
                          setPhone(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Lines")}</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Select
                        multiple
                        value={stores}
                        options={lines.map((q) => ({
                          key: q.id,
                          value: q.id,
                          text: q.name,
                        }))}
                        onChange={(e, d) => {
                          setStores(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("ECP")}</b>
                    </Table.Cell>
                    <Table.Cell>
                      {edit ? (
                        editing.isEcp ? (
                          <>{t("Attached")}</>
                        ) : (
                          <>
                            <ECPComponent setX509={setX509} />
                          </>
                        )
                      ) : (
                        <>
                          <ECPComponent setX509={setX509} />
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
              <div
                style={{
                  marginTop: 15,
                  marginBottom: 5,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button negative content={t("Cancel")} onClick={closeModal} />
                <Button
                  positive
                  content={t("Submit")}
                  onClick={() => {
                    if (edit) {
                      putEmployee(editing)
                    } else {
                      postEmployee()
                    }
                  }}
                  disabled={
                    !edit &&
                    (pwd === "" ||
                      pwd !== confPwd ||
                      login === "" ||
                      mail === "" ||
                      phone === "")
                  }
                />
              </div>
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  const renderECPCreate = () => {
    return (
      <>
        <Modal
          style={{ height: "max-content", marginTop: "-40vh" }}
          size="tiny"
          open={ecpCreate}
          onClose={() => {
            setX509("")
            setChoosed(null)
            setEcpCreate(false)
          }}
        >
          <Card fluid>
            <Card.Content>
              <div>
                <ECPComponent setX509={setX509} />
              </div>
              <Divider />
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Button
                  positive
                  content={t("Submit")}
                  onClick={() => {
                    putEmployee(choosed)
                  }}
                  disabled={x509 === ""}
                />
              </div>
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  return (
    <>
      {renderCreateEmployee()}
      {renderECPCreate()}
      {confirmDeleteRender()}
      <Dimmer active={isLoading} inverted>
        <Loader />
      </Dimmer>
      <div>
        <h2>{t("EmployeePage")}</h2>
        <div style={{ display: !isDel ? "block" : "none" }}>
          <Button
            positive
            content={t("Create employee")}
            onClick={() => {
              setModal(true)
            }}
          />
          <Button
            negative
            content={t("Delete employee")}
            style={{ marginLeft: 10 }}
            onClick={() => {
              setIsDel(true)
            }}
          />
        </div>
        <div style={{ display: isDel ? "block" : "none" }}>
          <Button
            content={t("Cancel delete")}
            color="yellow"
            onClick={() => {
              setIsDel(false)
            }}
          />
        </div>
        <div style={{ marginTop: 20 }}>
          <Card.Group>
            {employees.map((q) => (
              <>
                <Card>
                  <Card.Content>
                    <div
                      style={{
                        display: isDel ? "flex" : "none",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="close"
                        color="red"
                        onClick={() => {
                          setId(q.id)
                          setConfirming(true)
                          // deleteEmployee(q.id)
                          // setIsDel(false)
                        }}
                      />
                    </div>
                    <Table style={{ border: "0px solid red" }}>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Login")}:</b>
                          </Table.Cell>
                          <Table.Cell>{q.login}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Name Surname")}:</b>
                          </Table.Cell>
                          <Table.Cell>{q.name}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Email")}:</b>
                          </Table.Cell>
                          <Table.Cell>{q.mail}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Mobile phone")}:</b>
                          </Table.Cell>
                          <Table.Cell>{q.phone}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Lines")}</b>
                          </Table.Cell>
                          <Table.Cell>
                            {q.stores.map((q) => (
                              <>
                                <p>
                                  {lines
                                    .filter((w) => w.id === q)
                                    .map((w) => (
                                      <>{w.name}</>
                                    ))}
                                </p>
                              </>
                            ))}
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("ЭЦП")}</b>
                          </Table.Cell>
                          <Table.Cell>
                            {q.isEcp ? (
                              t("Attached")
                            ) : (
                              <Button
                                positive
                                content={t("Attach")}
                                onClick={() => {
                                  setChoosed(q)
                                  setEcpCreate(true)
                                }}
                              />
                            )}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <div
                      style={{
                        display: edit ? "none" : "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        content={t("Edit")}
                        positive
                        onClick={() => {
                          setStores(q.stores)
                          setEditing(q)
                          setEdit(true)
                          setModal(true)
                        }}
                      />
                    </div>
                  </Card.Content>
                </Card>
              </>
            ))}
          </Card.Group>
        </div>
      </div>
    </>
  )
}

export default EmployeePage
